<template>
  <b-modal
    modal-class="mc-modal-dashboard"
    :title="title"
    size="lg"
    centered
    hide-footer
    visible
    @hidden="$emit('close')"
  >
    <McTable
      :fields="fields"
      :apiClient="apiClient"
      :hasSelectAll="false"
      searchable
      :hasCheckbox="false"
      :customHandlers="{ handleClickRow }"
    >
      <template v-slot:[`cell(fleet_task.number)`]="{ value, item }">
        <p
          class="text-primary clickable-field"
          v-if="item.fleet_task.id"
          @click="handleClickFleetNumber(item)"
        >
          {{ value }}
        </p>
        <template v-else>-</template>
      </template>

      <template v-slot:[`cell(status.name)`]="{ value, item }">
        <template>
          <span
            v-if="item.status?.color"
            class="__status-dots"
            :style="{ backgroundColor: item.status.color }"
          ></span>
          <span style="color: #344264">{{ value }}</span>
        </template>
      </template>

      <template #cell(canceled_reason)="{ value }">
        <template>{{ value || '-' }}</template>
      </template>
    </McTable>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import tableFields from '../lib/fields/modalWidgetTableFields'
import * as Delivery from '@/services/rest-api/lib/delivery/delivery-order'
import McTable from '@/components/McTable'
import { formatEndDateFilter } from '../helpers/formatTime'

export default {
  components: {
    McTable,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    achievementDateRange: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      default: () => [],
    },
    modalTitle: {
      type: String,
    },
    deliveryOrderType: {
      type: String,
    },
  },
  emits: ['close'],
  data() {
    return {
      operator: {
        all_delivery: '',
        owner_delivery: 'is',
        vendor_delivery: 'is_not',
      },
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.modalTitle || this.$t(`delivery.status.${this.status.toLowerCase()}`)
    },
    fields() {
      return tableFields().filter((field) => {
        if (['DRAFT', 'CONFIRMED'].includes(this.status) && field.key === 'fleet_task.number') {
          return false
        }

        if (!['RESCHEDULED', 'CANCELED'].includes(this.status) && field.key === 'canceled_reason') {
          return false
        }

        if (
          !this.hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']) &&
          field.key === 'vendor.name'
        ) {
          return false
        }

        return true
      })
    },
    apiClient() {
      let filterParams = [`status.name eq ${this.status}`]
      const operator = this.operator[this.deliveryOrderType]
      !!operator && filterParams.push(`vendor.id ${operator} null`)

      // prenvet duplicates from the merged array
      filterParams = [...new Set([...filterParams, ...this.filters])]

      if (this.achievementDateRange.length > 0 && ['DELIVERED', 'CANCELED'].includes(this.status)) {
        filterParams.push(`updated_on gte ${this.achievementDateRange[0]}`)
        filterParams.push(`updated_on lte ${formatEndDateFilter(this.achievementDateRange[1])}`)
      }

      return { get: Delivery.get(filterParams) }
    },
  },
  methods: {
    handleClickRow(item) {
      this.openNewTab({ name: 'Delivery Detail', params: { id: item.id } })
    },
    handleClickFleetNumber(item) {
      this.openNewTab({ name: 'Fleet Task Detail', params: { id: item.fleet_task.id } })
    },
    openNewTab(routeData) {
      const route = this.$router.resolve(routeData)
      window.open(route.href, '_blank')
    },
  },
}
</script>
